(function () {
  'use strict';

  window.DipZip = window.DipZip || {};

  DipZip.getCookie = function (name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  };

  DipZip.setCookie = function (name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; expires=' + date.toUTCString() + '; path=/; SameSite=Lax';
  };

  // Draws the pH curve once it scrolls into view, respecting prefers-reduced-motion.
  DipZip.initScrollDraw = function () {
    var lines = document.querySelectorAll('[data-dz-draw-on-view]');
    if (!lines.length) return;
    if (!('IntersectionObserver' in window)) {
      lines.forEach(function (el) {
        el.classList.add('is-drawn');
      });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-drawn');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );
    lines.forEach(function (el) {
      observer.observe(el);
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    DipZip.initScrollDraw();

    // Sales popup: auto-dismiss after 5s, or on the close button.
    // Real order data must be supplied by the section (fed from an app such
    // as Fomo/Nudgify reading actual orders) — this file never fabricates one.
    var popup = document.querySelector('[data-dz-sales-popup]');
    if (popup) {
      var dismiss = function () {
        popup.setAttribute('hidden', '');
      };
      var closeBtn = popup.querySelector('[data-dz-popup-dismiss]');
      if (closeBtn) closeBtn.addEventListener('click', dismiss);
      window.setTimeout(dismiss, 5000);
    }
  });
})();
